define('adminColorSelectionsLibrariesPopupView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'windows',
  'template!adminColorSelectionsLibrariesPopupView',
  'entities/admin/color_selections'
], function (
  App,
  Module,
  _,
  $,
  Marionette,
  Bootbox,
  Windows,
  Tpl
) {
  'use strict';

  var normalizeHex = function (value) {
    var h = $.trim(value || '').toLowerCase().replace(/^#/, '');
    if (/^[0-9a-f]{3}$/.test(h)) {
      h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
    }
    return /^[0-9a-f]{6}$/.test(h) ? '#' + h : null;
  };

  var t = function (key, fallback) {
    return _.i18n('admin.colorSelections.' + key, null, fallback);
  };

  var reason = function (xhr) {
    return (xhr && xhr.responseJSON && xhr.responseJSON.error) ||
      _.i18n('common.error', null, 'Something went wrong. Please try again.');
  };

  // Spot libraries of the account (backend SpotLibraryService): create, rename,
  // delete an empty one; add / edit / delete its colours. Shared libraries are
  // listed only when they hold colours of the account, and only those colours.
  var View = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-color-selections-popup-libraries-view',

    ui: {
      newName: '.js-new-name',
      libraries: '.js-libraries',
      main: '.js-main',
      error: '.js-error'
    },

    events: {
      'click .js-create': 'onCreate',
      'keydown @ui.newName': 'onNewNameKey',
      'click .js-library': 'onPick',
      'click .js-rename': 'onRename',
      'click .js-delete-library': 'onDeleteLibrary',
      'click .js-edit-color': 'onEditColor',
      'click .js-delete-color': 'onDeleteColor',
      'input .js-f-picker': 'onPicker',
      'input .js-f-hex': 'onHexInput',
      'click .js-save-color': 'onSaveColor',
      'click .js-cancel-color': 'onCancelColor',
      'click .js-close': 'onClose'
    },

    initialize: function () {
      this.libraries = [];
      this.colors = [];
      this.current = null;
      this.editing = null;
      this.changed = false;
    },

    serializeData: function () {
      return {
        labels: {
          newPlaceholder: t('newLibraryPlaceholder', 'New library name'),
          create: t('createLibrary', 'Create'),
          sideHint: t('librariesHint', 'Shared libraries appear here only when they hold colours of your account.'),
          pick: t('pickLibrary', 'Choose or create a library.'),
          close: _.i18n('common.close', null, 'Close')
        }
      };
    },

    onShow: function () {
      this.loadLibraries();
    },

    onDestroy: function () {
      if (this.changed && this.options.onChanged) {
        this.options.onChanged();
      }
    },

    // ---- libraries ------------------------------------------------------
    loadLibraries: function (selectSecId) {
      var self = this;
      App.request('colorSelections:spot-libraries').done(function (libraries) {
        if (self.isDestroyed) { return; }
        self.libraries = libraries || [];
        self.renderLibraries();
        var wanted = selectSecId || (self.current && self.current.secId);
        var found = _.findWhere(self.libraries, { secId: wanted });
        if (found) {
          self.select(found);
        } else if (self.current) {
          self.current = null;
          self.ui.main.html('<div class="cs-empty">' + _.escape(t('pickLibrary', 'Choose or create a library.')) + '</div>');
        }
      }).fail(function (xhr) { self.showError(reason(xhr)); });
    },

    renderLibraries: function () {
      var current = this.current && this.current.secId;
      if (!this.libraries.length) {
        this.ui.libraries.html('<div class="cs-empty">' + _.escape(t('noLibrary', 'No library of your own yet.')) + '</div>');
        return;
      }
      this.ui.libraries.html(_.map(this.libraries, function (l) {
        return '<button type="button" class="sl-item js-library' + (l.secId === current ? ' active' : '') +
          '" data-secid="' + _.escape(l.secId) + '"><span class="sl-item-name">' + _.escape(l.name) + '</span>' +
          (l.shared ? '<span class="sl-tag">' + _.escape(t('shared', 'shared')) + '</span>' : '') +
          '<span class="sl-count">' + (l.colorCount || 0) + '</span></button>';
      }).join(''));
    },

    onNewNameKey: function (e) {
      if (e.which === 13) { this.onCreate(); }
    },

    onCreate: function () {
      var self = this;
      var name = $.trim(this.ui.newName.val());
      if (!name) { this.ui.newName.focus(); return; }
      this.hideError();
      App.request('colorSelections:spot-library:create', { name: name }).done(function (library) {
        if (self.isDestroyed) { return; }
        self.ui.newName.val('');
        self.changed = true;
        self.loadLibraries(library.secId);
      }).fail(function (xhr) { self.showError(reason(xhr)); });
    },

    onPick: function (e) {
      var library = _.findWhere(this.libraries, { secId: $(e.currentTarget).attr('data-secid') });
      if (library) { this.select(library); }
    },

    select: function (library) {
      var self = this;
      this.current = library;
      this.editing = null;
      this.renderLibraries();
      this.hideError();
      App.request('colorSelections:spot-colors', library.secId).done(function (colors) {
        if (self.isDestroyed || self.current !== library) { return; }
        self.colors = colors || [];
        self.renderMain();
      }).fail(function (xhr) { self.showError(reason(xhr)); });
    },

    onRename: function () {
      var self = this;
      var library = this.current;
      Bootbox.prompt({
        title: t('renameLibrary', 'Rename the library'),
        value: library.name,
        callback: function (value) {
          var name = $.trim(value || '');
          if (value === null || !name || name === library.name) { return; }
          App.request('colorSelections:spot-library:rename', library.secId, { name: name }).done(function () {
            if (self.isDestroyed) { return; }
            self.changed = true;
            self.loadLibraries(library.secId);
          }).fail(function (xhr) { self.showError(reason(xhr)); });
        }
      });
    },

    onDeleteLibrary: function () {
      var self = this;
      var library = this.current;
      Bootbox.confirm(t('confirmDeleteLibrary', 'Delete this library?') + ' <b>' + _.escape(library.name) + '</b>',
        function (ok) {
          if (!ok) { return; }
          App.request('colorSelections:spot-library:delete', library.secId).done(function () {
            if (self.isDestroyed) { return; }
            self.changed = true;
            self.current = null;
            self.loadLibraries();
          }).fail(function (xhr) { self.showError(reason(xhr)); });
        });
    },

    // ---- colours --------------------------------------------------------
    renderMain: function () {
      var library = this.current;
      var html = '<div class="sl-head"><h4>' + _.escape(library.name) +
        (library.shared ? ' <span class="sl-tag">' + _.escape(t('shared', 'shared')) + '</span>' : '') + '</h4>';
      if (!library.shared) {
        html += '<button type="button" class="btn btn-default btn-sm js-rename"><i class="fa fa-pencil"></i> ' +
          _.escape(t('rename', 'Rename')) + '</button>' +
          '<button type="button" class="btn btn-default btn-sm js-delete-library"' +
          (this.colors.length ? ' disabled title="' + _.escape(t('deleteLibraryHint', 'Delete its colours first')) + '"' : '') +
          '><i class="fa fa-trash"></i> ' + _.escape(_.i18n('common.delete', null, 'Delete')) + '</button>';
      }
      html += '</div>';
      if (library.shared) {
        html += '<div class="cs-hint">' + _.escape(t('sharedHint',
          'A shared library: only the colours your account added are listed, the others cannot be changed.')) + '</div>';
      }
      html += this.colorsTable() + this.colorForm();
      this.ui.main.html(html);
    },

    colorsTable: function () {
      if (!this.colors.length) {
        return '<div class="cs-empty sl-no-color">' + _.escape(t('noSpotColor', 'No colour yet: add one below.')) + '</div>';
      }
      var editing = this.editing && this.editing.secId;
      return '<div class="sl-colors"><table><thead><tr><th></th><th>' + _.escape(t('code', 'Code')) + '</th><th>' +
        _.escape(t('name', 'Name')) + '</th><th>Hex</th><th>C M Y K</th><th>' + _.escape(t('used', 'Used')) +
        '</th><th></th></tr></thead><tbody>' + _.map(this.colors, function (c, index) {
          return '<tr' + (c.secId === editing ? ' class="editing"' : '') + '>' +
            '<td><span class="cs-swatch" style="background:' + _.escape(c.hex) + '"></span></td>' +
            '<td class="sl-code">' + _.escape(c.code) + '</td><td>' + _.escape(c.name || '') + '</td>' +
            '<td class="sl-mono">' + _.escape((c.hex || '').toUpperCase()) + '</td>' +
            '<td class="sl-mono">' + [c.c, c.m, c.y, c.k].join(' ') + '</td>' +
            '<td>' + (c.usedCount || 0) + '</td>' +
            '<td class="sl-actions"><button type="button" class="btn btn-link js-edit-color" data-index="' + index +
            '"><i class="fa fa-pencil"></i></button><button type="button" class="btn btn-link js-delete-color" data-index="' +
            index + '"' + (c.usedCount ? ' disabled title="' + _.escape(t('usedHint', 'Used: remove it from where it is used first')) + '"' : '') +
            '><i class="fa fa-trash"></i></button></td></tr>';
        }).join('') + '</tbody></table></div>';
    },

    colorForm: function () {
      var c = this.editing || { code: '', name: '', hex: '#3a6dd8', c: null, m: null, y: null, k: null };
      var locked = !!(this.editing && this.editing.usedCount);
      var num = function (cls, value) {
        return '<input type="number" min="0" max="100" class="form-control sl-cmyk ' + cls + '" value="' +
          (value === null || value === undefined ? '' : value) + '"/>';
      };
      return '<div class="sl-form">' +
        '<div class="sl-form-title">' + _.escape(this.editing ? t('editSpotColor', 'Edit the colour') :
          t('addSpotColor', 'Add a colour')) + '</div>' +
        '<div class="sl-form-row">' +
        '<input type="text" class="form-control js-f-code" maxlength="255" placeholder="' + _.escape(t('code', 'Code')) +
        '" value="' + _.escape(c.code) + '"' + (locked ? ' disabled title="' +
          _.escape(t('codeLocked', 'The code of a colour in use cannot change')) + '"' : '') + '/>' +
        '<input type="text" class="form-control js-f-name" maxlength="255" placeholder="' +
        _.escape(t('nameOptional', 'Name (optional)')) + '" value="' + _.escape(c.name === c.code ? '' : (c.name || '')) + '"/>' +
        '</div><div class="sl-form-row">' +
        '<input type="color" class="js-f-picker" value="' + _.escape(c.hex || '#3a6dd8') + '"/>' +
        '<input type="text" class="form-control js-f-hex sl-hex" maxlength="7" value="' + _.escape(c.hex || '') + '"/>' +
        '<span class="sl-cmyk-label">C M Y K</span>' + num('js-f-c', c.c) + num('js-f-m', c.m) + num('js-f-y', c.y) +
        num('js-f-k', c.k) +
        '<button type="button" class="btn btn-primary js-save-color">' + _.escape(this.editing ?
          _.i18n('common.save', null, 'Save') : _.i18n('common.add', null, 'Add')) + '</button>' +
        (this.editing ? '<button type="button" class="btn btn-default js-cancel-color">' +
          _.escape(_.i18n('common.cancel', null, 'Cancel')) + '</button>' : '') +
        '</div><div class="cs-hint">' + _.escape(t('cmykHint',
          'CMYK from 0 to 100: the four or none. Hex is what screens show, CMYK what the print files use.')) + '</div></div>';
    },

    onPicker: function (e) {
      this.$('.js-f-hex').val($(e.currentTarget).val()).removeClass('invalid');
    },

    onHexInput: function (e) {
      var hex = normalizeHex($(e.currentTarget).val());
      $(e.currentTarget).toggleClass('invalid', !hex);
      if (hex) { this.$('.js-f-picker').val(hex); }
    },

    onEditColor: function (e) {
      this.editing = this.colors[parseInt($(e.currentTarget).attr('data-index'), 10)];
      this.renderMain();
      this.$('.js-f-name').focus();
    },

    onCancelColor: function () {
      this.editing = null;
      this.renderMain();
    },

    readNumber: function (cls) {
      var v = $.trim(this.$(cls).val());
      return v === '' ? null : parseInt(v, 10);
    },

    onSaveColor: function () {
      var self = this;
      var hex = normalizeHex(this.$('.js-f-hex').val());
      var json = {
        code: $.trim(this.$('.js-f-code').val()) || (this.editing && this.editing.code) || '',
        name: $.trim(this.$('.js-f-name').val()),
        hex: hex,
        c: this.readNumber('.js-f-c'),
        m: this.readNumber('.js-f-m'),
        y: this.readNumber('.js-f-y'),
        k: this.readNumber('.js-f-k')
      };
      if (!json.code) { this.$('.js-f-code').focus(); return; }
      if (!hex) { this.$('.js-f-hex').addClass('invalid').focus(); return; }
      var library = this.current;
      this.hideError();
      var request = this.editing ?
        App.request('colorSelections:spot-color:update', library.secId, this.editing.secId, json) :
        App.request('colorSelections:spot-color:create', library.secId, json);
      request.done(function () {
        if (self.isDestroyed) { return; }
        self.changed = true;
        self.loadLibraries(library.secId);
      }).fail(function (xhr) { self.showError(reason(xhr)); });
    },

    onDeleteColor: function (e) {
      var self = this;
      var color = this.colors[parseInt($(e.currentTarget).attr('data-index'), 10)];
      var library = this.current;
      Bootbox.confirm(t('confirmDeleteSpotColor', 'Delete this colour?') + ' <b>' + _.escape(color.code) + '</b>',
        function (ok) {
          if (!ok) { return; }
          App.request('colorSelections:spot-color:delete', library.secId, color.secId).done(function () {
            if (self.isDestroyed) { return; }
            self.changed = true;
            self.loadLibraries(library.secId);
          }).fail(function (xhr) { self.showError(reason(xhr)); });
        });
    },

    showError: function (message) {
      this.ui.error.text(message).show();
    },

    hideError: function () {
      this.ui.error.hide();
    },

    onClose: function () {
      if (this.windowView) { this.windowView.close(); }
    }
  });

  View.open = function (onChanged) {
    Windows.open({
      view: function () {
        return new View({ onChanged: onChanged });
      },
      title: t('librariesTitle', 'Spot libraries and spot colours of your account'),
      width: 960,
      height: 640,
      modal: true
    });
  };

  Module.exports = View;
});

